import $ from 'jquery';
import IMask from 'imask';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';
import validationRules from '../../common/utils/validation';

class ReferFriend {
    constructor() {
        this.scrollToOffset = $('header').height();
        this.scrollToElement = undefined;
        this.firstSubmit = false;
        this.valid = true;
        this.validPhone = false;
    }

    init() {
        this.bindEvents();
        this.setupInputmask();
    }

    // validateYourNames() {
    //     let yourName = $('#your-full-name').val();
    //     if (yourName === undefined || yourName === '') {
    //         $('#your-full-name ~ .field-validation-error').removeClass('hidden');
    //         this.scrollToElement = $('#your-full-name');
    //         this.valid = false;
    //     } else {
    //         $('#your-full-name ~ .field-validation-error').addClass('hidden');
    //     }
    // }

    validateYourFirstName() {
        let yourName = $('#your-first-name').val();
        if (yourName === undefined || yourName === '') {
            $('#your-first-name ~ .field-validation-error').removeClass('hidden');
            $('#your-first-name').addClass('error');
            this.scrollToElement = $('#your-first-name');
            this.valid = false;
        } else {
            $('#your-first-name ~ .field-validation-error').addClass('hidden');
            $('#your-first-name').removeClass('error');
        }
    }

    validateYourLastName() {
        let yourName = $('#your-last-name').val();
        if (yourName === undefined || yourName === '') {
            $('#your-last-name ~ .field-validation-error').removeClass('hidden');
            $('#your-last-name').addClass('error');
            this.scrollToElement = $('#your-last-name');
            this.valid = false;
        } else {
            $('#your-last-name ~ .field-validation-error').addClass('hidden');
            $('#your-last-name').removeClass('error');
        }
    }

    validateFriendsFirstName() {       
        let friendName = $('#friend-first-name').val();
        if (friendName === undefined || friendName === '') {
            $('#friend-first-name ~ .field-validation-error').removeClass('hidden');
            $('#friend-first-name').addClass('error');
            this.scrollToElement = $('#friend-first-name');
            this.valid = false;
        } else {
            $('#friend-first-name ~ .field-validation-error').addClass('hidden');
            $('#friend-first-name').removeClass('error');
        }
    }

    validateFriendsLastName() {       
        let friendName = $('#friend-last-name').val();
        if (friendName === undefined || friendName === '') {
            $('#friend-last-name ~ .field-validation-error').removeClass('hidden');
            $('#friend-last-name').addClass('error');
            this.scrollToElement = $('#friend-last-name');
            this.valid = false;
        } else {
            $('#friend-last-name ~ .field-validation-error').addClass('hidden');
            $('#friend-last-name').removeClass('error');
        }
    }

    validateEmail() {
        let email = $('#email');
        if (email.val() === undefined || email.val() === '') {
            $('#email ~ .field-validation-error').html("Please enter your friend's email address.");
            $('#email ~ .field-validation-error').removeClass('hidden');
            $('#email').addClass('error');
            this.scrollToElement = email;
            this.valid = false;
        } else if (!validationRules.emailValidate(email)) {
            $('#email ~ .field-validation-error').html('Please enter a valid email address.');
            $('#email ~ .field-validation-error').removeClass('hidden');
            $('#email').addClass('error');
            this.scrollToElement = email;
            this.valid = false;
        } else {
            $('#email ~ .field-validation-error').addClass('hidden');
            $('#email').removeClass('error');
        }
    }

    validatePhone() {
        if (this.validPhone === true) {
            $('#phone-number ~ .field-validation-error').addClass('hidden');
            $('#phone-number').removeClass('error');
        } else {
            this.scrollToElement = $('#phone-number');
            $('#phone-number ~ .field-validation-error').removeClass('hidden');
            $('#phone-number').addClass('error');
            this.valid = false;
        }
    }

    validateCity() {
        let city = $('#city').val();
        if (city === undefined || city === '') {
            $('#city ~ .field-validation-error').removeClass('hidden');
            $('#city').addClass('error');
            this.scrollToElement = $('#city');
            this.valid = false;
        } else {
            $('#city ~ .field-validation-error').addClass('hidden');
            $('#city').removeClass('error');
        }
    }

    validateState() {
        let state = $('#state-select').val();
        if (state === '') {
            $('#state-select ~ .field-validation-error').removeClass('hidden');
            $('#state-select').addClass('error');
            this.scrollToElement = $('#state-select');
            this.valid = false;
        } else {
            $('#state-select ~ .field-validation-error').addClass('hidden');
            $('#state-select').removeClass('error');
        }
    }

    scrollToError() {
        if (this.scrollToElement !== undefined || this.scrollToOffset !== undefined) {
            $('html, body').animate({ scrollTop: $(this.scrollToElement).offset().top - this.scrollToOffset }, 750);
        }
    }

    doValidation() {
        // validate data in reverse verticle order => top most scrollToElement
        this.valid = true;  // try and make me false
        this.validateState();
        this.validateCity();
        this.validatePhone();
        this.validateEmail();
        // this.validateFriendsNames();
        this.validateFriendsLastName();
        this.validateFriendsFirstName();
        // this.validateYourNames();
        this.validateYourLastName();
        this.validateYourFirstName();
        // scroll to 1st error
        if (this.valid === false) {
            if (this.firstSubmit === false) {
                this.firstSubmit = true;
                // add new events for better ux post 1st submit : realtime validation msging
                this.eventsAfterSubmitionFail();
            }
            this.scrollToError();
            return false;
        } else {
            return true;
        }
    }

    eventsAfterSubmitionFail() {    
        // $('#your-full-name').on('change keyup', () => this.validateYourNames());
        $('#your-first-name').on('keyup', () => this.validateYourFirstName());
        $('#your-last-name').on('keyup', () => this.validateYourLastName());
        // $('#friend-full-name').on('change keyup', () => this.validateFriendsNames());
        $('#friend-first-name').on('keyup', () => this.validateFriendsFirstName());
        $('#friend-last-name').on('keyup', () => this.validateFriendsLastName());
        $('#email').on('change keyup', () => this.validateEmail());
        $('#phone-number').on('change keyup', () => this.validatePhone());
        $('#city').on('change keyup', () => this.validateCity());
        $('#state-select').change(() => this.validateState());
    }

    bindEvents() {
        $('.js-refer-friend').on('click', (e) => {
            e.preventDefault();
            if (this.doValidation()) {
                grecaptcha.ready(() => {
                  grecaptcha.execute($('g-recaptcha').data('sitekey'), { action: 'referSubmit' }).then((token) => {
                        $('#g-recaptcha-response').val(token);
                        $('.js-refer-friend').attr('disabled', true);
                        $('.js-refer-friend').addClass('disabled');
                        $('.js-refer-friend').css('pointer-events', 'none');
                        $('form.refer-friend-form').submit();
                    });
                });
            }
        });
        $('#state-select').on('change', (e) => {
            e.preventDefault();
            $('#state-select').blur();
        });
    }

    setupInputmask() {
        let phoneSelector = document.getElementById('phone-number');
        let maskOptions = {
            mask: '(000) 000-0000'
        };
        let mask = IMask(phoneSelector, maskOptions);
        mask.on('accept', () => { this.validPhone = false; this.validatePhone(); });
        mask.on('complete', () => { this.validPhone = true; this.validatePhone(); });
    }
}

export default ReferFriend;

$(() => {
	const referFriend = new ReferFriend();
	referFriend.init();
});